import { AuthState } from '@okta/okta-auth-js';

import { FutureTradeEntries } from '../../services/backend/FutureTradeEntries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFutureTradeEntries: () => FutureTradeEntries<AuthState> = () => {
  return useBaseApiClient(FutureTradeEntries);
};
